/** FAQ, Support, and Advertising page copy (French). */
export const pagesMessagesFr = {
  faq: {
    pageTitle: "Foire aux questions",
    pageSubtitle: "Trouvez les réponses aux questions les plus fréquentes sur WasOK",
    seoTitle: "FAQ — WasOK",
    seoDescription:
      "Réponses aux questions fréquentes sur WasOK, le scan de produits, la confidentialité et les évaluations.",
    items: [
      {
        question: "Comment fonctionne WasOK ?",
        answer:
          "WasOK vous aide à vous souvenir des produits que vous avez aimés ou non en scannant leurs codes-barres et en enregistrant vos notes et commentaires. Il vous suffit de scanner le code-barres d'un produit, de le noter, d'ajouter des commentaires, et la prochaine fois que vous scannerez le même produit, vous verrez instantanément votre avis précédent.",
      },
      {
        question: "Mes données sont-elles stockées dans le cloud ?",
        answer:
          "Non ! Toutes vos données sont stockées localement sur votre appareil. Nous ne synchronisons pas vos informations avec le cloud, ce qui signifie que votre historique d'achats et vos opinions sur les produits restent totalement privés. Cela signifie toutefois que vous devez sauvegarder votre appareil si vous souhaitez conserver vos données.",
      },
      {
        question: "Ai-je besoin d'une connexion internet pour utiliser WasOK ?",
        answer:
          "Non, WasOK fonctionne entièrement hors ligne. Comme toutes vos données sont stockées localement sur votre appareil, vous pouvez scanner des produits, ajouter des notes et consulter votre historique sans aucune connexion internet.",
      },
      {
        question: "Puis-je utiliser WasOK pour tout type de produit ?",
        answer:
          "Oui ! WasOK fonctionne avec tout produit possédant un code-barres. Qu'il s'agisse d'alimentation, de cosmétiques, d'articles ménagers, d'électronique ou de tout autre produit avec un code-barres, vous pouvez le scanner et enregistrer votre avis.",
      },
      {
        question: "Comment scanner un code-barres ?",
        answer:
          "Ouvrez simplement l'application WasOK et appuyez sur le bouton de scan. Pointez votre appareil photo vers le code-barres du produit, et l'application le détectera et le scannera automatiquement. Assurez-vous que le code-barres est bien éclairé et net pour de meilleurs résultats.",
      },
      {
        question: "Puis-je ajouter des photos à mes avis sur les produits ?",
        answer:
          "Oui ! Vous pouvez joindre des photos à n'importe quel avis sur un produit. C'est particulièrement utile pour vous souvenir des détails de l'emballage, de la liste des ingrédients ou de toute autre information visuelle qui pourrait vous aider à vous rappeler pourquoi vous avez aimé ou non un produit.",
      },
      {
        question: "Quelles informations puis-je enregistrer sur les produits ?",
        answer:
          "Vous pouvez enregistrer des notes (1 à 5 étoiles), des commentaires écrits, des photos, le prix payé, le lieu d'achat et des catégories personnalisées. Ces informations complètes vous aident à prendre des décisions éclairées lors de vos achats.",
      },
      {
        question: "Puis-je créer des listes de courses ?",
        answer:
          "Oui ! WasOK vous permet de créer des listes de courses à partir des produits que vous avez déjà évalués. Cela vous permet de vous souvenir facilement des produits que vous avez adorés et que vous voulez racheter.",
      },
      {
        question: "Comment organiser mes produits ?",
        answer:
          "Vous pouvez organiser vos produits à l'aide de catégories personnalisées. Par exemple, vous pourriez créer des catégories comme « Snacks », « Café », « Soins de la peau » ou « Produits d'entretien ». Cela facilite la consultation de vos avis par type.",
      },
      {
        question: "WasOK est-il gratuit ?",
        answer:
          "Oui, WasOK est entièrement gratuit à télécharger et à utiliser. Il n'y a aucun achat intégré, abonnement ou frais caché. Nous pensons que tout le monde devrait avoir accès à un moyen privé de se souvenir de ses préférences en matière de produits.",
      },
      {
        question: "WasOK est-il accessible ?",
        answer:
          "WasOK est conçu pour être utilisable par le plus grand nombre. L'application inclut des fonctionnalités d'accessibilité telles que la prise en charge des lecteurs d'écran, un texte adaptable et un mode contraste élevé optionnel.",
      },
      {
        question: "Que se passe-t-il si je désinstalle l'application ?",
        answer:
          "Comme toutes les données sont stockées localement sur votre appareil, désinstaller l'application supprimera tous vos avis sur les produits, vos notes et vos listes de courses. Pensez à exporter vos données si vous souhaitez conserver une sauvegarde avant de désinstaller.",
      },
      {
        question: "Puis-je exporter mes données ?",
        answer:
          "Oui, WasOK vous permet d'exporter vos données à des fins de sauvegarde. Vous pouvez exporter tous vos avis dans un fichier que vous pouvez enregistrer sur votre appareil ou dans le stockage cloud de votre choix.",
      },
      {
        question: "WasOK suit-il ma localisation ?",
        answer:
          "Non, WasOK ne suit pas votre localisation. Bien que vous puissiez saisir manuellement le nom du magasin où vous avez acheté un produit, l'application n'utilise ni GPS ni services de localisation.",
      },
      {
        question: "Puis-je utiliser WasOK sur plusieurs appareils ?",
        answer:
          "Actuellement, WasOK ne se synchronise pas entre les appareils puisque toutes les données sont stockées localement. Chaque appareil aura sa propre base de données distincte de produits et d'avis.",
      },
      {
        question: "Que faire si un code-barres ne se scanne pas ?",
        answer:
          "Si un code-barres ne se scanne pas, assurez-vous qu'il est bien éclairé et net. Vous pouvez également essayer de nettoyer l'objectif de l'appareil photo. Si le code-barres est endommagé ou peu lisible, vous pourrez peut-être saisir manuellement son numéro.",
      },
    ],
    cta: {
      heading: "Vous avez encore des questions ?",
      body: "Contactez notre équipe support — nous serons ravis de vous aider.",
      button: "Contacter le support",
    },
  },
  support: {
    pageTitle: "Support",
    seoTitle: "Support — WasOK",
    seoDescription:
      "Besoin d'aide avec WasOK : contactez le support, signalez des bugs et partagez vos retours.",
    getHelp: {
      title: "Obtenir de l'aide",
      body: "Nous sommes là pour vous aider à tirer le meilleur parti de WasOK. Si vous rencontrez des problèmes ou avez des questions, plusieurs ressources sont à votre disposition.",
    },
    faq: {
      title: "Foire aux questions",
      body: "Avant de nous contacter, consultez notre foire aux questions, où nous répondons aux questions les plus courantes sur WasOK. Vous y trouverez des informations détaillées sur le fonctionnement de l'application, la confidentialité, le stockage des données, et plus encore.",
    },
    contact: {
      title: "Contacter le support",
      body: "Si vous ne trouvez pas la réponse que vous cherchez, notre équipe support est prête à vous aider. Vous pouvez nous joindre à :",
      emailLabel: "E-mail :",
      responseTime: "Nous répondons généralement sous 24 à 48 heures",
    },
    bugs: {
      title: "Signaler des bugs",
      body: "Vous avez trouvé un bug ? Nous apprécions votre aide pour améliorer WasOK. Lorsque vous signalez un bug, veuillez inclure :",
      items: [
        "Une description détaillée du problème",
        "Les étapes pour reproduire le problème",
        "Le modèle de votre appareil et la version d'Android",
        "Des captures d'écran ou enregistrements d'écran si possible",
      ],
      sendPrefix: "Envoyez les signalements de bugs à :",
    },
    featureRequests: {
      title: "Demandes de fonctionnalités",
      bodyBefore: "Vous avez une idée de nouvelle fonctionnalité ? Nous serions ravis de vous entendre ! Envoyez vos suggestions à",
      bodyAfter:
        ". Bien que nous ne puissions pas mettre en œuvre chaque demande, nous prenons en compte tous les retours lors de la planification des futures mises à jour.",
    },
    knownIssues: {
      title: "Problèmes connus",
      body: "Nous avons actuellement connaissance des problèmes suivants et travaillons à les résoudre :",
      items: [
        "Certains codes-barres peuvent ne pas se scanner en faible luminosité — essayez d'utiliser une lampe torche",
        "Les notes de produits très longues peuvent mettre un moment à s'enregistrer sur les appareils plus anciens",
        "Les miniatures d'images peuvent apparaître pixelisées sur les écrans haute résolution",
      ],
    },
    appUpdates: {
      title: "Mises à jour de l'application",
      body: "Nous publions régulièrement des mises à jour avec de nouvelles fonctionnalités, des améliorations et des corrections de bugs. Pensez à maintenir WasOK à jour via le Google Play Store pour bénéficier des dernières améliorations.",
    },
    community: {
      title: "Communauté",
      body: "Rejoignez notre communauté d'utilisateurs qui font des choix d'achat plus intelligents avec WasOK. Partagez des astuces, posez des questions et échangez avec d'autres utilisateurs sur nos réseaux sociaux.",
    },
    emergency: {
      title: "Assistance urgente",
      body: 'Si vous rencontrez un problème critique qui vous empêche d\'utiliser l\'application, veuillez indiquer « URGENT » dans l\'objet de votre e-mail, et nous traiterons votre demande en priorité.',
    },
    cta: {
      heading: "Besoin d'aide supplémentaire ?",
      body: "Notre équipe support est là pour vous. N'hésitez pas à nous contacter pour toute question ou préoccupation.",
      button: "Contacter le support par e-mail",
    },
  },
  advertising: {
    pageTitle: "Publicité et monétisation",
    seoTitle: "Publicité — WasOK",
    seoDescription: "Comment WasOK aborde la publicité et la monétisation.",
    approach: {
      title: "Notre approche",
      body: "Chez WasOK, nous pensons que vos habitudes d'achat et vos opinions sur les produits sont privées et personnelles. Notre modèle économique reflète cette valeur fondamentale.",
    },
    noAds: {
      title: "Aucune publicité",
      body: "WasOK n'affiche aucune publicité. Nous ne vous montrerons jamais d'annonces basées sur les produits que vous scannez, les notes que vous donnez ou toute autre donnée que vous créez dans l'application. Votre expérience avec WasOK est entièrement sans publicité.",
    },
    noDataSelling: {
      title: "Aucune vente de données",
      body: "Nous ne vendons, ne louons ni ne partageons vos données avec des publicitaires, des courtiers en données ou tout autre tiers. Comme toutes vos données sont stockées localement sur votre appareil, nous n'y avons même pas accès. Vos avis sur les produits, vos listes de courses et vos notes n'appartiennent qu'à vous.",
    },
    noTracking: {
      title: "Aucun suivi",
      body: "WasOK n'utilise ni pixels de suivi, ni services d'analyse, ni aucune autre technologie qui surveille votre comportement ou partage des informations avec des tiers. Nous ne suivons pas les produits que vous scannez, les magasins où vous faites vos achats, ni la manière dont vous utilisez l'application.",
    },
    sustainability: {
      title: "Comment nous restons durables",
      body: "Vous vous demandez peut-être comment nous gardons WasOK gratuit sans publicité ni vente de données. Notre approche est simple :",
      items: [
        {
          label: "Gratuit et ouvert :",
          text: "WasOK est gratuit pour tout le monde, sans niveaux premium ni barrières payantes",
        },
        {
          label: "Fonctionnement allégé :",
          text: "Nous maintenons nos coûts bas en développant un logiciel efficace et respectueux de la vie privée",
        },
        {
          label: "Dons facultatifs :",
          text: "Les utilisateurs qui aiment WasOK peuvent nous soutenir par des dons volontaires",
        },
        {
          label: "Open source :",
          text: "Nous proposons éventuellement des services de conseil ou de développement sur mesure pour des organisations",
        },
      ],
    },
    noAffiliate: {
      title: "Aucun lien d'affiliation",
      body: "WasOK n'utilise pas de liens d'affiliation et ne perçoit aucune commission de la part des détaillants. Lorsque vous scannez un produit, nous ne vous redirigeons vers aucun site pour l'acheter. L'application sert uniquement à votre suivi personnel et à votre prise de décision.",
    },
    noPromotions: {
      title: "Aucune promotion de produits",
      body: "Nous n'acceptons aucun paiement de la part de marques ou de fabricants pour promouvoir leurs produits. WasOK ne vous suggérera jamais de produits, ne mettra jamais en avant certaines marques et n'influencera en aucune façon vos notes. Vos opinions n'appartiennent qu'à vous.",
    },
    partnerships: {
      title: "Partenariats avec des tiers",
      body: "WasOK ne s'associe pas avec des entreprises de marketing, des agrégateurs de données ou des réseaux publicitaires. Nous fonctionnons de manière indépendante et faisons de votre vie privée notre priorité absolue.",
    },
    future: {
      title: "Projets futurs",
      body: "Nous nous engageons à maintenir WasOK sans publicité et axé sur la confidentialité. Si nous devions un jour introduire un modèle économique durable, nous nous engageons à :",
      items: [
        "Annoncer tout changement bien à l'avance",
        "Ne jamais compromettre la confidentialité ou la sécurité des données",
        "Toujours proposer un moyen d'utiliser l'application sans suivi ni publicité",
        "Écouter les retours et les préoccupations des utilisateurs",
      ],
    },
    supporting: {
      title: "Soutenir WasOK",
      body: "Si vous aimez WasOK et souhaitez soutenir notre mission de mémoire d'achat respectueuse de la vie privée, vous pouvez :",
      items: [
        "Parler de l'application à vos amis et à votre famille",
        "Laisser un avis positif sur le Google Play Store",
        "Partager vos retours et suggestions avec nous",
        "Envisager un don volontaire (lorsqu'il sera disponible)",
      ],
    },
    cta: {
      heading: "Des questions sur nos politiques ?",
      body: "Nous sommes transparents sur le fonctionnement de WasOK. Si vous avez des questions sur notre approche en matière de confidentialité, de monétisation ou de durabilité, n'hésitez pas à nous contacter.",
      button: "Nous contacter",
    },
  },
};
